import { axios } from '@pukka/auth';
import { MOKA_GOAUTH_SERVICE } from '@pukka/common/constants';

import { AccountDeletionModel } from '../models';

const ACCOUNT_DELETION_URL = `${MOKA_GOAUTH_SERVICE}/business-service/v1/businesses/business-deletion-tickets`;

async function createAccountDeletionTicket(payload: AccountDeletionModel.CreatePayload): Promise<AccountDeletionModel.CreateResponse> {
  const { data } = await axios.post(ACCOUNT_DELETION_URL, payload);

  return data;
}

export { ACCOUNT_DELETION_URL, createAccountDeletionTicket };
